document.addEventListener('DOMContentLoaded', function () {
  var isApplyingPreferredVariant = false;

  function hasSku(variant) {
    return !!(variant && typeof variant.sku === 'string' && variant.sku.trim() !== '');
  }

  function optionNumber(indexKey) {
    var match = String(indexKey || '').match(/option(\d+)/);
    return match ? parseInt(match[1], 10) : 0;
  }

  function normalizeOptionValue(value) {
    return String(value || '').trim().toLowerCase();
  }

  function getMetalwareIndexKey(container) {
    if (!container) return null;

    var inputs = container.querySelectorAll('[data-variant-input]');
    var valuesByIndex = {};

    for (var i = 0; i < inputs.length; i += 1) {
      var input = inputs[i];
      var indexKey = input.dataset.index;
      if (!indexKey) continue;

      if (!valuesByIndex[indexKey]) {
        valuesByIndex[indexKey] = {};
      }

      valuesByIndex[indexKey][normalizeOptionValue(input.value)] = true;
    }

    var optionKeys = Object.keys(valuesByIndex);
    for (var j = 0; j < optionKeys.length; j += 1) {
      var key = optionKeys[j];
      var values = Object.keys(valuesByIndex[key]);
      if (values.indexOf('gold') !== -1 && values.indexOf('silver') !== -1) {
        return key;
      }
    }

    return null;
  }

  function weightedMatchCount(variant, selectedValues, maxOptionIndex) {
    return selectedValues.reduce(function (count, option) {
      if (optionNumber(option.index) > maxOptionIndex) return count;
      var weight = 4 - optionNumber(option.index);
      return variant[option.index] === option.value ? count + weight : count;
    }, 0);
  }

  function findContainerFromEventDetail(detail) {
    var indexKey = detail && detail.index ? detail.index : '';
    var value = detail && typeof detail.value === 'string' ? detail.value : '';
    if (!indexKey || value === '') return null;

    var candidates = document.querySelectorAll('input[data-variant-input][data-index="' + indexKey + '"]');
    for (var i = 0; i < candidates.length; i += 1) {
      var input = candidates[i];
      if (input.value !== value) continue;
      if (!input.checked) continue;

      var container = input.closest('[data-section-type="product"]');
      if (container) return container;
    }

    return null;
  }

  function choosePreferredVariant(variants, selectedValues, lastSelectedIndex) {
    function pickBest(candidates) {
      if (!candidates.length) return null;
      return candidates.reduce(function (best, next) {
        if (!best) return next;
        var bestCount = weightedMatchCount(best, selectedValues, 3);
        var nextCount = weightedMatchCount(next, selectedValues, 3);
        return nextCount > bestCount ? next : best;
      }, null);
    }

    function filterEligible(requireAvailable, optionLimit) {
      var branchOptions = selectedValues.filter(function (option) {
        return optionNumber(option.index) <= optionLimit;
      });

      return variants.filter(function (variant) {
        if (!hasSku(variant)) return false;
        if (requireAvailable && !variant.available) return false;

        return branchOptions.every(function (option) {
          return variant[option.index] === option.value;
        });
      });
    }

    var selectedLimit = optionNumber(lastSelectedIndex) || 3;

    // Try strict-to-relaxed matching:
    // 3->2->1 lets us drop stale lower option (metalware) while preserving model/color.
    for (var limit = selectedLimit; limit >= 1; limit -= 1) {
      var bestInStock = pickBest(filterEligible(true, limit));
      if (bestInStock) return bestInStock;

      var bestRealSku = pickBest(filterEligible(false, limit));
      if (bestRealSku) return bestRealSku;
    }

    return null;
  }

  function syncInputsToVariant(container, variant) {
    if (!container || !variant) return;

    var optionInputs = container.querySelectorAll('[data-variant-input]');
    optionInputs.forEach(function (input) {
      var index = input.dataset.index;
      var desiredValue = variant[index];
      if (typeof desiredValue === 'undefined') return;

      var type = input.getAttribute('type');
      if (type === 'radio' || type === 'checkbox') {
        input.checked = normalizeOptionValue(input.value) === normalizeOptionValue(desiredValue);
      } else {
        if (normalizeOptionValue(input.value) !== normalizeOptionValue(desiredValue)) {
          input.value = desiredValue;
        }
      }
    });
  }

  function getCheckedInputValue(container, indexKey) {
    if (!container || !indexKey) return null;
    var checkedInput = container.querySelector('[data-variant-input][data-index="' + indexKey + '"]:checked');
    return checkedInput ? checkedInput.value : null;
  }

  function getVariantInput(container, indexKey, value) {
    if (!container || !indexKey || typeof value === 'undefined') return null;

    var candidates = container.querySelectorAll('[data-variant-input][data-index="' + indexKey + '"]');
    var desiredValue = normalizeOptionValue(value);
    for (var i = 0; i < candidates.length; i += 1) {
      if (normalizeOptionValue(candidates[i].value) === desiredValue) {
        return candidates[i];
      }
    }

    return null;
  }

  function enforceVariantUiState(container, variant, dispatchChange) {
    if (!container || !variant) return;

    syncInputsToVariant(container, variant);

    var metalwareIndexKey = getMetalwareIndexKey(container);
    if (!metalwareIndexKey) return;

    var desiredMetalwareValue = variant[metalwareIndexKey];
    if (!desiredMetalwareValue) return;

    var desiredMetalwareInput = getVariantInput(container, metalwareIndexKey, desiredMetalwareValue);
    if (!desiredMetalwareInput) return;

    if (normalizeOptionValue(getCheckedInputValue(container, metalwareIndexKey)) === normalizeOptionValue(desiredMetalwareValue)) return;

    desiredMetalwareInput.checked = true;
    desiredMetalwareInput.click();
  }

  function scheduleUiEnforcement(container, variant, dispatchChange) {
    if (!container || !variant) return;

    [0, 40, 120, 220].forEach(function(delay) {
      window.setTimeout(function() {
        enforceVariantUiState(container, variant, dispatchChange && delay === 0);
      }, delay);
    });
  }

  function getProductContainer(detail) {
    return findContainerFromEventDetail(detail) || document.querySelector('[data-section-type="product"]');
  }

  function getVariantByMasterSelect(container) {
    if (!container) return null;
    var variantsJsonEl = container.querySelector('[data-variant-json]');
    var masterSelect = container.querySelector('[data-product-select]');
    if (!variantsJsonEl || !masterSelect) return null;

    var variants;
    try {
      variants = JSON.parse(variantsJsonEl.textContent || variantsJsonEl.innerHTML || '[]');
    } catch (e) {
      return null;
    }
    if (!Array.isArray(variants)) return null;

    var selectedId = parseInt(masterSelect.value, 10);
    if (!Number.isFinite(selectedId)) return null;
    return variants.find(function (variant) { return variant.id === selectedId; }) || null;
  }

  function syncUiWithMasterVariant(container) {
    var settledVariant = getVariantByMasterSelect(container);
    if (!settledVariant) return;
    enforceVariantUiState(container, settledVariant, false);
  }

  function applyVariantSelection(container, variant) {
    var optionInputs = container.querySelectorAll('[data-variant-input]');
    var firstChangedInput = null;

    optionInputs.forEach(function (input) {
      var index = input.dataset.index;
      var desiredValue = variant[index];
      if (typeof desiredValue === 'undefined') return;

      var type = input.getAttribute('type');
      if (type === 'radio' || type === 'checkbox') {
        var shouldCheck = input.value === desiredValue;
        if (input.checked !== shouldCheck) {
          input.checked = shouldCheck;
          if (shouldCheck && !firstChangedInput) {
            firstChangedInput = input;
          }
        }
      } else {
        if (input.value !== desiredValue) {
          input.value = desiredValue;
          if (!firstChangedInput) {
            firstChangedInput = input;
          }
        }
      }
    });

    if (firstChangedInput) {
      firstChangedInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  document.addEventListener('variant:change', function (event) {
    if (isApplyingPreferredVariant) return;

    var detail = event && event.detail ? event.detail : null;
    if (!detail || !Array.isArray(detail.currentlySelectedValues)) return;

    var container = getProductContainer(detail);
    if (!container) return;

    var currentVariant = detail.variant;
    var selectedIndex = optionNumber(detail.index);
    var metalwareIndexKey = getMetalwareIndexKey(container);
    var metalwareOptionNumber = optionNumber(metalwareIndexKey);

    if (currentVariant) {
      // Keep UI controls in sync with the real selected variant ID.
      syncInputsToVariant(container, currentVariant);

      // If a higher-level option changed and the real variant resolves to
      // different metalware, keep enforcing that visible state until the
      // theme finishes its own availability updates.
      if (
        metalwareIndexKey &&
        metalwareOptionNumber &&
        selectedIndex < metalwareOptionNumber &&
        currentVariant[metalwareIndexKey]
      ) {
        var activeMetalwareValue = getCheckedInputValue(container, metalwareIndexKey);
        if (normalizeOptionValue(activeMetalwareValue) !== normalizeOptionValue(currentVariant[metalwareIndexKey])) {
          scheduleUiEnforcement(container, currentVariant, true);
          return;
        }
      }
    }

    // Also force-sync from the master select after variant logic settles.
    window.setTimeout(function () {
      syncUiWithMasterVariant(container);
    }, 30);

    // If the user changed a higher-level option (ex: model/color),
    // always re-evaluate to the best in-stock real SKU for that branch.
    // If they changed a lower-level option (ex: metalware), only auto-correct invalid states.
    if (
      selectedIndex >= 3 &&
      currentVariant &&
      currentVariant.available &&
      hasSku(currentVariant)
    ) {
      return;
    }

    var variantsJsonEl = container.querySelector('[data-variant-json]');
    if (!variantsJsonEl) return;

    var variants;
    try {
      variants = JSON.parse(variantsJsonEl.textContent || variantsJsonEl.innerHTML || '[]');
    } catch (e) {
      return;
    }

    if (!Array.isArray(variants) || !variants.length) return;

    var preferredVariant = choosePreferredVariant(variants, detail.currentlySelectedValues, detail.index);
    if (!preferredVariant) return;
    if (currentVariant && preferredVariant.id === currentVariant.id) return;

    isApplyingPreferredVariant = true;
    try {
      applyVariantSelection(container, preferredVariant);
    } finally {
      window.setTimeout(function () {
        isApplyingPreferredVariant = false;
      }, 0);
    }
  });

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.matches || !target.matches('[data-product-select]')) return;
    var container = target.closest('[data-section-type="product"]');
    if (!container) return;
    syncUiWithMasterVariant(container);
    window.setTimeout(function () {
      syncUiWithMasterVariant(container);
    }, 80);
  });
});
